import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_6: FaireProductEntity = {
  token: "catalog_prod_prod-6",
  type: "product",
  name: "Birthday Mug - This Is My Birthday Mug",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=400&h=400&fit=crop",
  priceDollars: 33.82,
  msrpDollars: 84.55,
  sku: "CO0006",
  caseSize: 6,
  material: "Glass",
  collectionToken: "col_confetti-cake",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 399,
  description: "Beautiful Confetti & Cake piece perfect for any home.",
  categoryTokens: ["catalog_cat_home-accents"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
